
import { Box } from '@mui/material';
import Description from './components/Description/Description';
import Documents from './components/Documents/Documents';
import Partners from './components/Partners/Partners';

const InfoTab = () => {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px"
      }}
    >
      <Description />
      <Documents />
      <Partners />
    </Box>
  );
};

export default InfoTab;